<div class="col-lg-12 content-scroll-screen parent">
  <p-card>
    <div class="d-flex align-items-center gap-3 mb-3">
      <h2 class="mb-0">Buyer</h2>
      @if (loading()) {
        <jni-spinner></jni-spinner>
      }
    </div>
    <p-table
      #dt
      [value]="buyers()"
      [paginator]="true"
      [rows]="defaultRows"
      [rowsPerPageOptions]="[10, 25, 50]"
      [filterDelay]="0"
      [stripedRows]="true"
      [rowHover]="true"
      [scrollable]="buyers().length > 0"
      [scrollHeight]="buyers().length > 0 ? 'calc(100vh - 260px)' : undefined"
      [styleClass]="
        buyers().length > 0 ? 'table-listing' : 'table-listing no-data-table'
      "
      size="small"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} buyers">
      <ng-template #header>
        <tr class="table-head text-capitalize">
          @for (column of columns; track column.field) {
            <th [pSortableColumn]="column.field">
              {{ column.label }}
              <p-sortIcon class="ms-1" [field]="column.field" />
            </th>
          }
        </tr>
        <tr class="sort-row">
          @for (column of columns; track column.field) {
            <th>
              <input
                [formControl]="column.filterControl"
                pInputText
                type="text"
                class="p-column-filter"
                placeholder="Search"
                [attr.aria-label]="'Filter ' + column.label"
                (input)="
                  dt.filter($any($event.target).value, column.field, 'contains')
                " />
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr>
          <td>{{ item.clientId }}</td>
          <td>{{ item.clientName }}</td>
          <td>{{ item.buyerName }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.sampleAddress }}</td>
          <td>{{ item.sampleSize }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage
        ><tr>
          <td colspan="6" class="no-data-cell border-0">
            @if (loading() || !hasLoaded()) {
              <div
                class="d-flex align-items-center justify-content-center text-center h-100 w-100">
                Loading buyers…
              </div>
            } @else if (loadError()) {
              <p-message severity="error">
                Unable to load buyers from the Client Portal. Please refresh to
                try again.
              </p-message>
            } @else {
              <div
                class="d-flex align-items-center justify-content-center flex-column text-center h-100 w-100">
                <span class="no-data-image d-block w-25 h-25 mb-4"></span>
                <h3 class="fw-medium fs-5 mb-2">No Data found</h3>
              </div>
            }
          </td>
        </tr></ng-template
      >
    </p-table>
  </p-card>
</div>
